import PropTypes from "prop-types";
import "./CustomTableGrid.css";

export default function CustomTableGrid({ columns, rows, rowKey = "id", gridTemplateColumns }) {
  const template = gridTemplateColumns || `repeat(${columns.length}, 1fr)`;
  return (
    <div className="ctg-grid" style={{ gridTemplateColumns: template }}>
      {/* Header */}
      {columns.map((col) => (
        <div key={col?.key} className="ctg-header-cell">{col?.label}</div>
      ))}

      {/* Rows */}
      {rows?.map((row, rowIndex) =>
        columns?.map((col, colIndex) => (
          <div
            key={`${row[rowKey] ?? rowIndex}-${col?.key}`}
            className={`ctg-cell ${colIndex === 0 ? "ctg-row-start" : ""} ${colIndex === columns?.length - 1 ? "ctg-row-end" : ""}`}
          >
            {col?.render ? col.render(row) : row[col?.key]}
          </div>
        ))
      )}
    </div>
  );
}

CustomTableGrid.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      render: PropTypes.func,
    })
  ).isRequired,
  rows: PropTypes.array.isRequired,
  rowKey: PropTypes.string,
  gridTemplateColumns: PropTypes.string,
};
